shadow$provide[319] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Types:{enumerable:true, get:function() {
  return require$_DOT__SLASH_types_typed.Types;
}}});
var require$_DOT__SLASH_classes_DOT_js = require("./classes.js");
var require$_DOT__SLASH_types_typed = require("./types_typed");
var require$_DOT__SLASH_traits = require("./traits");
var require$_DOT__SLASH_helpers_DOT_js = require("./helpers.js");
require.exportCopy(module, require$_DOT__SLASH_classes_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_traits);
require.exportCopy(module, require$_DOT__SLASH_helpers_DOT_js);

};